/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ paginÄ',
  jump_to: 'Mergi la',
  jump_to_confirm: 'confirm',
  page: '',

  // Pagination.jsx
  prev_page: 'Pagina AnterioarÄ',
  next_page: 'Pagina UrmÄtoare',
  prev_5: '5 Pagini Anterioare',
  next_5: '5 Pagini UrmÄtoare',
  prev_3: '3 Pagini Anterioare',
  next_3: '3 Pagini UrmÄtoare'
};
